import React, { useState, useContext, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  FaBible,
  FaBars,
  FaSearch,
  FaHome,
} from 'react-icons/fa';

import logo from './image/logo2.png';
import './TopHeader.css';
import { AuthContext } from '../Authentication/AuthContext';
import {
  getBibleDownloadCacheSnapshot,
  startBibleDownloadCache,
  subscribeBibleDownloadCache,
} from '../Bible/DownloadCache';

function TopHeader() {
  const { language, setLanguage } = useContext(AuthContext);

  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname);
  const [menuOpen, setMenuOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState('');
  const [downloadCacheStatus, setDownloadCacheStatus] = useState(() =>
    getBibleDownloadCacheSnapshot()
  );

  useEffect(() => {
    setActiveMenu(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    const unsubscribe = subscribeBibleDownloadCache((nextStatus) => {
      setDownloadCacheStatus(nextStatus);
    });

    startBibleDownloadCache();

    return unsubscribe;
  }, []);

  const handleMenuClick = (path, name) => {
    setActiveMenu(path);
    setSelectedMenu(name);
    setMenuOpen(false);
  };

  const toggleMenu = () => {
    setMenuOpen((previousValue) => !previousValue);
  };

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;

    setLanguage(selectedLanguage);
    localStorage.setItem('language', selectedLanguage);
  };

  const getMenuItems = () => {
    if (language === 'English') {
      return {
        home: 'HOME',
        articles: 'Articles',
        bible: 'Bible',
        verses: 'Verses',
        words: 'Words',
      };
    }

    if (language === 'Deutsch') {
      return {
        home: 'Zuhause',
        articles: 'Artikel',
        bible: 'Bibel',
        verses: 'Verse',
        words: 'Wörter',
      };
    }

    return {
      home: 'முகப்பு',
      articles: 'கட்டுரைகள்',
      bible: 'வேதாகமம்',
      verses: 'வசனங்கள்',
      words: 'சொற்கள்',
    };
  };

  const getSelectedLanguageText = () => {
    if (language === 'English') {
      return 'Language';
    }

    if (language === 'Deutsch') {
      return 'Sprache';
    }

    return 'மொழி';
  };

  const getCacheStatusLabel = () => {
    if (downloadCacheStatus.status === 'ready') {
      return 'Bible cache ready';
    }

    if (downloadCacheStatus.status === 'ready_with_errors') {
      return 'Bible cache ready';
    }

    if (downloadCacheStatus.status === 'running') {
      return 'Bible cache downloading';
    }

    if (downloadCacheStatus.status === 'checking') {
      return 'Bible cache checking';
    }

    if (downloadCacheStatus.status === 'error') {
      return 'Bible cache error';
    }

    return 'Bible cache waiting';
  };

  const menuItems = getMenuItems();
  const selectedLanguageText = getSelectedLanguageText();

  return (
    <div>
      <div className="top-header">
        <div className="logo-menu-container">
          <div className="logo-container">
            <Link
              to="/home"
              className="logo-link"
              onClick={() => handleMenuClick('/home', menuItems.home)}
            >
              <img src={logo} alt="Logo" className="logo" />
            </Link>
          </div>

          <div className="menu-toggle" onClick={toggleMenu}>
            {selectedMenu && (
              <span className="selected-menu">{selectedMenu}</span>
            )}

            <FaBars size={25} />
            MENU
          </div>

          <div className={`menu ${menuOpen ? 'open' : ''}`}>
            <Link
              to="/home"
              className={`menu-item ${activeMenu === '/home' ? 'active' : ''}`}
              onClick={() => handleMenuClick('/home', menuItems.home)}
            >
              <FaHome size={25} />
              {menuItems.home}
            </Link>

            <Link
              to="/Categories"
              className={`menu-item ${
                activeMenu === '/Categories' ? 'active' : ''
              }`}
              onClick={() => handleMenuClick('/Categories', menuItems.articles)}
            >
              <FaBars size={25} />
              {menuItems.articles}
            </Link>

            <Link
              to="/bible"
              className={`menu-item ${
                activeMenu === '/bible' ? 'active' : ''
              }`}
              onClick={() => handleMenuClick('/bible', menuItems.bible)}
            >
              <FaBible size={20} />
              {menuItems.bible}
            </Link>

            <Link
              to="/bible-verse-find"
              className={`menu-item ${
                activeMenu === '/bible-verse-find' ? 'active' : ''
              }`}
              onClick={() =>
                handleMenuClick('/bible-verse-find', menuItems.verses)
              }
            >
              <FaSearch size={20} />
              {menuItems.verses}
            </Link>

            <Link
              to="/search-verse-by-word"
              className={`menu-item ${
                activeMenu === '/search-verse-by-word' ? 'active' : ''
              }`}
              onClick={() =>
                handleMenuClick('/search-verse-by-word', menuItems.words)
              }
            >
              <FaSearch size={20} />
              {menuItems.words}
            </Link>
          </div>

          <div className="header-cache-status-badge">
            <span className="header-cache-label">{getCacheStatusLabel()}</span>
            <span className="header-cache-percent">
              {downloadCacheStatus.percent}%
            </span>
            <span className="header-cache-count">
              {downloadCacheStatus.completed}/{downloadCacheStatus.total}
            </span>
          </div>
        </div>
      </div>

      <div className="contact-info">
        <div className="social-icons">
          <Link to="/privacypolicy" className="privacy-policy-link">
            Privacy Policy
          </Link>

          <Link to="/support" className="support-link">
            Support
          </Link>
        </div>

        <div className="language-selector">
          <label htmlFor="language-select">{selectedLanguageText}: </label>

          <select
            id="language-select"
            value={language}
            onChange={handleLanguageChange}
          >
            <option value="English">English</option>
            <option value="Deutsch">Deutsch</option>
            <option value="தமிழ்">தமிழ்</option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default TopHeader;